import { useNavigate } from 'react-router-dom';
import { PolicyModal } from '../components/waitlist/PolicyModal';
import { privacyPolicy } from '../data/policies';
import { usePageMeta } from '../hooks/usePageMeta';

export function Privacy() {
  const navigate = useNavigate();

  usePageMeta({
    title: 'Privacy Policy - PCNGuard',
    description: 'PCNGuard privacy policy. How we collect, use, and protect your data under GDPR.',
    canonical: 'https://pcnguard.co.uk/privacy',
  });

  const handleClose = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen text-slate-50 selection:bg-emerald-500/30 font-sans bg-[#050505]">
      <PolicyModal
        title="Privacy Policy"
        subtitle="Full PCNGuard privacy policy."
        lastUpdated="09/12/2025"
        content={privacyPolicy}
        onClose={handleClose}
      />
    </div>
  );
}

export default Privacy;
